<!-- <script src="https://cdnjs.cloudflare.com/ajax/libs/ace/1.2.6/ace.js"></script> -->
<div>
  <json-editor
    [options]="editorOptions"
    (change)="changeLog($event)"
    [data]="json"
    #editor
  ></json-editor>
</div>
<div class="text-right mt-3">
  <button class="btn btn-secondary mr-2" (click)="close.emit()">
    <i class="fa fa-remove"></i> Close
  </button>
  <button class="btn btn-green" (click)="onAdd()" *ngIf="allowAdd">
    <i class="fa fa-edit" ></i> Add
  </button>
  <ng-container *ngIf="allowUpdate">
    <button class="btn btn-green" *ngIf="!disableUpdate" (click)="onUpdate()" >
      <i class="fa fa-edit" ></i> Update
    </button>
    <button class="btn btn-green" *ngIf="disableUpdate" disabled >
      <i class="fa fa-edit" ></i> Update
    </button>
  </ng-container>
  
  
</div>